/**
 * Pure renewal / upgrade decisions for the school form.
 * Covered by scripts/test-renewal-cycle.js.
 */

import { accreditationLevelRank, normalizeAccreditationLevel } from './accreditationLevel.js';

const PORTAL_LEVELS = ['foundation', 'certified', 'global'];

export function cycleIsFinalised(workflowStep) {
  return String(workflowStep || '').toLowerCase() === 'finalised';
}

/** Portal levels strictly above the school's current award. */
export function higherAccreditationLevels(current) {
  const rank = accreditationLevelRank(current);
  return PORTAL_LEVELS.filter((level) => accreditationLevelRank(level) > rank);
}

/** Pricing and Stripe use `accredited` for Global. */
export function billingLevelForPortal(portalLevel) {
  return normalizeAccreditationLevel(portalLevel) === 'global'
    ? 'accredited'
    : normalizeAccreditationLevel(portalLevel);
}

export function canonicalLevel(raw) {
  return normalizeAccreditationLevel(raw);
}
